import React from "react";
import { string, bool, func, oneOf, oneOfType } from "prop-types";
import InvalidFeedback, { hasErrors } from "./InvalidFeedback";
import classnames from "classnames";

/**
 * Stateless, controlled checkbox input
 */
StatelessCheckbox.propTypes = {
  id: string.isRequired,
  errors: InvalidFeedback.propTypes.errors,
  label: oneOfType([string, oneOf([false])]).isRequired,
  labelFirst: bool,
  checked: bool,
  onChangedValue: func,
  onChange: func,
  className: string,
};

export default function StatelessCheckbox({
  id,
  label,
  labelFirst,
  checked = false,
  onChangedValue = null,
  className = null,
  errors,
  onChange = null,
  ...props
}) {
  const _onChange = (event) => {
    onChange && onChange(event);
    onChangedValue && onChangedValue(event.target.checked);
  };

  return (
    <div className={classnames("form-check", className)}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        className={classnames("form-check-input", {
          "is-invalid": hasErrors(errors),
        })}
        {...props}
        onChange={_onChange}
      />
      <label
        htmlFor={id}
        className={classnames("form-check-label", {
          "label-first": labelFirst,
        })}
      >
        {label !== false ? label : " "}
      </label>
      <InvalidFeedback errors={errors} />
    </div>
  );
}
